<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <ORadioGroup v-model="model" :disabled="normalizedDisabled" :code="code" @change="(attrs.onChange)"></ORadioGroup>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormRadioGroupProps } from './RadioGroup'
import ORadioGroup from '../../Input/RadioGroup/RadioGroup.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormRadiogroup', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, required, code } = defineProps<FormRadioGroupProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
